import {SPACING} from "./constants";

function createCheckboxWithLabel(labelText, checkboxId){
    const container = document.createElement('div');
    const checkbox = document.createElement('input');
    const label = document.createElement('label');

    checkbox.type = 'checkbox';
    // checkbox.checked = true; //Checkbox types are checked by default

    //Enable toggle via label click
    checkbox.id = checkboxId;
    label.setAttribute('for', checkboxId);

    label.innerText = labelText;

    container.append(label);
    container.append(checkbox);

    return {
        container,
        checkbox,
        label
    }
}


/**
 * @param {HTMLElement} containerElement
 * @param {String[]} types
 * @param {Object<String, number>} typeHeights
 * @param {Object<String, Number>} typeYStartPositions
 * @param {String[]} displayedTypes
 */
function renderTypeLegend(
    containerElement,
    types,
    typeHeights,
    typeYStartPositions,
    displayedTypes
) {
    const containerHeight = 30;

    types.forEach((type, index) => {
        let yPosition = typeYStartPositions[type];
        yPosition += (typeHeights[type] / 2); //Center control
        yPosition -= index * containerHeight; //Elements use relative positioning, prevent misalignment by keeping in mind the previous element

        //Offset needs to be calculated on a per element basis due to relative positioning
        // const offset = index * containerHeight;

        const { container, checkbox } = createCheckboxWithLabel(
            type,
            `__SANKEY_TYPE_${index}`
        );

        container.classList.add('toggle-container', 'type-toggle-container');

        //Attempt to position in center
        container.style.top = yPosition + 'px';
        container.style.height = containerHeight + 'px';

        checkbox.checked = displayedTypes.includes(type);
        checkbox.addEventListener('click', function() {
            if(this.checked){
                if(!displayedTypes.includes(type)){
                    displayedTypes.push(type);
                }
            } else {
                const typeIndex = displayedTypes.indexOf(type);
                if(typeIndex !== -1){
                    displayedTypes.splice(typeIndex, 1);
                }
            }
        });

        containerElement.appendChild(container);
    });
}

/**
 * @param {HTMLElement} containerElement
 * @param {Number} maxDepth
 */
function renderTouchpointLegend(containerElement, maxDepth) {
    const getTouchpointLabel = index => {
        switch(index) {
            case 0:
                return 'start';
            case 1:
                return '1st';
            case 2:
                return '2nd';
            case 3:
                return '3rd';
            default:
                return `${index}th`;
        }
    }

    for(let touchpointIndex = 0; touchpointIndex <= maxDepth; touchpointIndex++){
        const xPosition = SPACING.HORIZONTAL * touchpointIndex;
        
        const { container, checkbox } = createCheckboxWithLabel(
            getTouchpointLabel(touchpointIndex),
            `__SANKEY_TOUCHPOINT_${touchpointIndex}`
        );

        checkbox.checked = true; //Checkboxes are checked by default
        container.classList.add('toggle-container', 'touchpoint-toggle-container');

        //Position under box
        container.style.left = (xPosition - 20) + 'px';

        containerElement.appendChild(container);
    }
}

/**
 * Create an element containing a set of controls for altering the displayed depth
 * @param {HTMLElement} containerElement
 * @param {JourneyBuilder.Sankey.ValueRef<number>} displayedDepth
 * @param {Number} maxDepth
 * @return {HTMLElement} Element containing depth alteration controls
 */
function renderDepthAlterationControls(containerElement, displayedDepth, maxDepth){
    const createControlButton = depthIncrease => {
        const btn = document.createElement('button');
        btn.classList.add('btn', 'btn-default');
        btn.innerText = depthIncrease > 0 ? `+${depthIncrease}` : depthIncrease;

        btn.addEventListener('click', () => displayedDepth.value += depthIncrease);
        
        //Assume we are initialized at max depth
        btn.disabled = depthIncrease > 0;
        
        //Buttons increasing our depth should be disabled when all levels are displayed
        //buttons decreasing our depth should be disabled when the smallest possible level is displayed
        displayedDepth.subscribe(newValue => {
            if(depthIncrease > 0) {
                btn.disabled = newValue >= maxDepth;
            } else {
                btn.disabled = newValue < 1;
            }
        });

        return btn;
    };

    const depthAlterationWrapper = document.createElement('div');

    const collapseContainer = depthAlterationWrapper.appendChild(document.createElement('div'));
    const expandContainer = depthAlterationWrapper.appendChild(document.createElement('div'));

    collapseContainer.classList.add('d-inline-block', 'mr-3');
    expandContainer.classList.add('d-inline-block');

    collapseContainer.appendChild(document.createElement('div')).innerText = 'Collapse';
    expandContainer.appendChild(document.createElement('div')).innerText = 'Expand';

    const collapseElementWrapper = collapseContainer.appendChild(document.createElement('div'));
    const expandElementWrapper = expandContainer.appendChild(document.createElement('div'));

    collapseElementWrapper.append(
        createControlButton(-10),
        ' ',
        createControlButton(-1)
    );

    expandElementWrapper.append(
        createControlButton(1),
        ' ',
        createControlButton(10)
    );

    containerElement.appendChild(depthAlterationWrapper);
}

export {
    renderTypeLegend,
    renderTouchpointLegend,
    renderDepthAlterationControls
}